// extracted by mini-css-extract-plugin
module.exports = {"page":"ProjectDocumentsPage_page__d52Jd","attach":"ProjectDocumentsPage_attach__3F8nJ"};